/**
 * Updated by Daniel on 7/18/2023, Added function to wrap automatically, and changed the font-size by the text.
 */

import { Component, OnInit, ElementRef, OnDestroy, HostListener, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { Subscription, Subject } from 'rxjs';

import { TamDashboardActions, TamDashboardEvents } from '../tam-dashboard.model';
import { filter } from 'rxjs/operators';
import { TamDashboardTileBaseComponent } from '../tam-dashboard-tile.base.component';
import { TamDashboardBaseConfiguration } from '../tam-dashboard-tile.base.config';

@Component({
    selector: 'tam-dashboard-value-tile',
    templateUrl: './tam-dashboard-value-tile.component.html',
    styleUrls: ['./tam-dashboard-value-tile.component.scss']
})
export class TamDashboardValueTileComponent implements OnInit, AfterViewInit, OnDestroy, TamDashboardTileBaseComponent {
    readonly?: boolean;
    data: any = {
        color: '#282828',
        value: null,
        valueText: 'N/A'
    };
    fontSize = 52;

    private _config: TamDashboardBaseConfiguration;
    private _destroySubscriptions: Array<Subscription> = [];
    private _afterViewFeedback$ = new Subject<string>();
    private _fontSizeCalculator: (parentWidth: number) => any = (parentWidth: number) => undefined;

    constructor(
        private _el: ElementRef,
        private _changeDetectorRef: ChangeDetectorRef,
    ) { }

    ngOnInit() {
    }

    ngAfterViewInit(): void {
        this._afterViewFeedback$.next(TamDashboardEvents.TILE_AFTER_VIEW_INIT);
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(element => element.unsubscribe());
        if (this._config) {
            this._config.destroy();
        }
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this._setFontSizeByResize();
    }

    setConfig(config: TamDashboardBaseConfiguration) {
        // modify reason, same as pie chart
        this._config = config;
        this._init();
        return true;
    }

    onSeriesClick() {
        if (this._config) {
            this._config.onSeriesClick();
        }
    }

    private _init() {
        this._destroySubscriptions.forEach(element => element.unsubscribe());
        this._destroySubscriptions.push(
            this._config.actionSubject$.pipe(
                filter((action: any) => action && action.id === this._config.id),
            ).subscribe(action => this._onSubscribeActions(action)),
            this._afterViewFeedback$.subscribe((payload) => {
                if (payload === TamDashboardEvents.TILE_AFTER_VIEW_INIT) {
                    this._config.feedbackSubject$.next({
                        type: TamDashboardEvents.TILE_AFTER_VIEW_INIT,
                        id: this._config.id
                    });
                }
            })
        );
        this.readonly = this._config.readonly;
    }

    private _onSubscribeActions(action) {
        if (action.type === TamDashboardActions.SET_TILE_DATA) {
            if (action.payload === null || action.payload.data === null) {
                this.data = {
                    color: '#282828',
                    value: null,
                    valueText: 'N/A'
                };
                this._config.feedbackSubject$.next({
                    type: TamDashboardEvents.TILE_LOADED_DATA,
                    id: this._config.id
                });
            } else {
                this.data = action.payload.data;
                this._fontSizeCalculator = action.payload.fontSizeCalculator;
                this._setFontSizeByResize(true);
            }
            this._changeDetectorRef.detectChanges();
        }
    }

    private _setFontSizeByResize(markSetData = false) {
        setTimeout(() => {
            // grid tile change type to value tile
            if (this._fontSizeCalculator) {
                this.fontSize = this._fontSizeCalculator(this._el.nativeElement.children[0].offsetWidth);
                if (markSetData) {
                    this._config.feedbackSubject$.next({
                        type: TamDashboardEvents.TILE_LOADED_DATA,
                        id: this._config.id
                    });
                }
            }
        }, 250);
    }
}
